'use client';

import * as React from 'react';
import { useIsMyProfile } from '../../hooks/use-is-my-profile';
import { PrivateProfileOverview } from './private-profile-overview';
import { PublicProfileOverview } from './public-profile-overview';
export const ProfileOverview = React.memo(function ProfileOverview() {
  const isMyProfile = useIsMyProfile();
  return isMyProfile ? <PrivateProfileOverview /> : <PublicProfileOverview />;
});